import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast6 extends BCComponent {

    render() {
        return (
            <div>
                <h1>HRY A APLIKACE</h1>
                <div className='separate-bottom'>
                    <p>Zajímavou cestou, jak se (finančně) vzdělávat, je zahrát si nějakou hru. Hra má tu výhodu, že nové vědomosti a dovednosti získáme zábavně formou zážitku, a tak se nám dostanou lépe pod kůži. Existuje nespočet her/aplikací, které nám mohou pomoci nasát do sebe základní znalosti z oblasti financí, ekonomie či podnikání.</p>
                </div>

                { this.showTask("zs_hry_1") }
                { this.showTask("zs_hry_2") }
                { this.showTask("zs_hry_3") }
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast6);
